import {
  SWAP_SETTINGS_KEYS,
  ADD_LIQUIDITY_SETTINGS_KEYS,
} from '@/components/common/Settings/settingKeys';
import { DEFAULT_EXECUTION_DEADLINE_DELTA_SECONDS } from '@/constants';
import { convertPercentageBigIntToString } from '@/utils/bigInt';
import { DEFAULT_MAX_SLIPPAGE_PERCENT } from '@/utils/constants';

import { SlippageSettingValue } from './SlippageSetting';
import { TxDeadlineSettingValue } from './TxDeadlineSetting';

// Default slippage settings
export const DEFAULT_SLIPPAGE_SETTINGS: SlippageSettingValue = {
  maxSlippagePercent: convertPercentageBigIntToString(DEFAULT_MAX_SLIPPAGE_PERCENT),
  autoMaxSlippage: true,
};

// Default transaction deadline settings
export const DEFAULT_TX_DEADLINE_SETTINGS: TxDeadlineSettingValue = {
  txExpireIn: DEFAULT_EXECUTION_DEADLINE_DELTA_SECONDS,
  autoTxDeadline: true,
};

// All default application settings grouped by domain
export const DEFAULT_SETTINGS = {
  // Swap settings
  [SWAP_SETTINGS_KEYS.SLIPPAGE]: DEFAULT_SLIPPAGE_SETTINGS,
  [SWAP_SETTINGS_KEYS.TX_DEADLINE]: DEFAULT_TX_DEADLINE_SETTINGS,

  [ADD_LIQUIDITY_SETTINGS_KEYS.TX_DEADLINE]: DEFAULT_TX_DEADLINE_SETTINGS,
};
